/* eslint-disable class-methods-use-this */
import { IAllCourse } from "../models/allcourse.model";
import { ICenter, ICenterResponse } from "../models/centers.model";
import { Course } from "../models/trainee-course.model";
import getService from "./getService";
import postService from "./postService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";

const GETALLCENTRES = "centres";
const GETALLCOURSES = "courses";
const GETEACHCOURSE = "courses/";
const GETCOURSETYPES = "course-types";
const PRE_REGISTRATION = "auth/register";
const KITREGISTRATION = "user/kits";
const CERTIFICATION = "user/certifications";

class RegistrationServices {
  async getAllCentres() {
    const response = await getService.get(`${CONFIG_API_URL}${GETALLCENTRES}`);
    const res: ICenter[] = response.data.data;
    return res;
  }
  async getAllCourses() {
    const response = await getService.get(`${CONFIG_API_URL}${GETALLCOURSES}`);
    return response.data.data;
  }
  async getEachCourse(course_id: any) {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETEACHCOURSE}${course_id}`
    );

    const res: IAllCourse = response.data.data;
    return res;
  }
  async getCourseTypes() {
    const response = await getService.get(`${CONFIG_API_URL}${GETCOURSETYPES}`);

    return response;
  }
  async updateCertification(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CERTIFICATION}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }
  async updateKitSize(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${KITREGISTRATION}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }
  async preRegistration(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${PRE_REGISTRATION}`,
      data
    );

    return response.data;
  }

  async trackApplication(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}course-enrollments/status`,
      data
    );
    return response.data;
  }
  async getAnnouncements() {
    const response = await getService.get(
      `${CONFIG_API_URL}general-announcements`
    );
    return response.data;
  }

  async getEachAnnouncementLanding(announcement_id: any) {
    const response = await getService.get(
      `${CONFIG_API_URL}general-announcements/${announcement_id}`
    );
    return response.data;
  }

  async downloadTrainingCalendar() {
    const response = await getService.get(
      `${CONFIG_API_URL}training-calendar`
    );
    return response.data;
  }

  async getAllUpcomingCourses(filter: any) {
    const response = await getService.get(`${CONFIG_API_URL}${GETALLCOURSES}${filter}`);
    return response.data.data;
  }

}

export default new RegistrationServices();
